import { Box, styled, Typography } from '@mui/material';

const UNSEEN_COUNT_DISPLAYABLE_LIMIT = 99;

const UnseenCountBubbleContainer = styled(Box)<{ empty?: boolean }>(({ theme, empty }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '0 0 auto',
  minWidth: '1.5rem',
  maxWidth: '1.7rem',
  height: '1.25rem',
  padding: `0 ${theme.spacing(1)}`,
  marginTop: '0.2rem',
  backgroundColor: empty
    ? theme.palette.custom.OV.sys.outlineVariant
    : theme.palette.primary.light,
  color: theme.palette.custom.OV.sys.onSecondary,
  borderRadius: '6.25rem',
}));

export const CountBubbleCell = ({
  count: rawCount = 0,
  limit = UNSEEN_COUNT_DISPLAYABLE_LIMIT,
}: {
  count?: number;
  limit?: number;
}) => {
  const count = rawCount > limit ? `${limit}+` : rawCount;

  return (
    !!count && (
      <UnseenCountBubbleContainer>
        <Typography variant="body1" fontSize="small" component="span">
          {count}
        </Typography>
      </UnseenCountBubbleContainer>
    )
  );
};
